import { TextField, VFFTextFieldAdapter } from '@eventbrite/design-ops-ds';
import { InputField } from '@eventbrite/eds-input-field';
import { ValidationFormField } from '@eventbrite/eds-validation-form-field';
import { gettext } from '@eventbrite/i18n';
import React, { FunctionComponent } from 'react';
import { checkCardImprovementsFeatureGate } from '../../utils/statsig';
import {
    CARD_POSTAL_CODE_FIELD_NAME,
    MAX_POSTAL_CODE_LENGTH,
} from './constants';
import './paymentInfoFields.scss';
import type { ShouldDisplayError } from './types';

export const PostalCodeField: FunctionComponent<{
    onChange: (value: string, name: string) => void;
    onBlur: (value: string, name: string) => void;
    shouldDisplayError?: ShouldDisplayError;
    shouldDisplayRequired?: boolean;
}> = ({ onChange, onBlur, shouldDisplayError, shouldDisplayRequired }) => {
    const postalCodeInput = checkCardImprovementsFeatureGate() ? (
        <VFFTextFieldAdapter onBlur={onBlur} onChange={onChange}>
            <TextField
                autoComplete="cc-postal-code"
                data-automation="card-postal-code-field"
                id="postal-code"
                label={gettext('Zip/Postal')}
                maxLength={MAX_POSTAL_CODE_LENGTH}
                required={shouldDisplayRequired}
            />
        </VFFTextFieldAdapter>
    ) : (
        <InputField
            autoComplete="cc-postal-code"
            id="postal-code"
            label={gettext('Zip/Postal')}
            required={shouldDisplayRequired}
            maxLength={MAX_POSTAL_CODE_LENGTH}
            onBlur={onBlur}
            onChange={onChange}
            data-automation="card-postal-code-field"
        />
    );
    return (
        <ValidationFormField
            shouldDisplayError={shouldDisplayError}
            name={CARD_POSTAL_CODE_FIELD_NAME}
            required={shouldDisplayRequired}
            v2={true}
        >
            {postalCodeInput}
        </ValidationFormField>
    );
};
